import React, { useState } from "react";
import "./TransactionBrokerTable.scss";
import Button from "../../Button/Button";
import { HiPencil } from "react-icons/hi";
import { MdDelete } from "react-icons/md";
import { useDispatch } from "react-redux";
const TransacionBrokerTable = ({
  UserTransactionData,
  tableFor,
  heading,
  Amount,
  handleDeleteModal,
  handleToggleFun,
}) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
 
  return (
    <>
      <div>
        <div className="sectionHeadings">{heading}</div>
        {UserTransactionData?.length > 0 ? (
          <table className="mainTablediv" style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              {tableFor === "Payment" ? (
                <tr>
                  <th>Date</th>
                  <th>Transporter Account</th>
                  <th>Credit Account</th>
                  <th>Narration</th>
                  <th className="amount">Debit Amount</th>
                </tr>
              ) : tableFor === "Receipt" ? (
                <tr>
                  <th>Date</th>
                  <th>Party Account</th>
                  <th>Debit Account</th>
                  <th>Narration</th>
                  <th className="amount">Amount</th>
                </tr>
              ) : (
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Remark</th>
                </tr>
              )}
            </thead>
            <tbody>
              {tableFor === "Delivery"
                ? UserTransactionData?.length > 0 &&
                  UserTransactionData.map((e, i) => (
                    <tr key={i}>
                      <td>{e?.Delivery_Date}</td>
                      <td>{e?.Delivery_Time}</td>
                      <td>{e?.Delivery_Remark}</td>
                    </tr>
                  ))
                : UserTransactionData?.length > 0 &&
                  UserTransactionData.map((e, i) => (
                    <tr key={i}>
                      <td>{e?.Date}</td>
                      <td>{e?.Transporter_Account}</td>
                      <td>{e?.Credit_Account}</td>
                      <td>{e?.Narration}</td>
                      <td className="amount">{e?.Debit_Amount}</td>
                      <td
                        onClick={() => {
                          setOpen(true);
                          dispatch({ type: "SET_CURRENT_KEY", payload: tableFor });
                          const payloadData = {
                            key:
                              e?.Entry_Type === "Journal Voucher"
                                ? "Journal_Voucher"
                                : e?.Entry_Type === "Bank Payment"
                                ? "Bank_Payment"
                                : e?.Entry_Type === "Bank Receipt"
                                ? "Bank_Receipt"
                                : e?.Entry_Type === "Cash Payment"
                                ? "Bank_Payment"
                                : e?.Entry_Type === "Cash Receipt"
                                ? "Bank_Payment"
                                : e?.Entry_Type === "Contra Voucher"
                                ? "Contra_Voucher"
                                : "",
                            data: { Selected_Row: e },
                          };
                          dispatch({
                            type: "UNIQUE_TABLE_LIST",
                            payload: payloadData,
                          });
                          dispatch({
                            type: "SET_COMPONENT_PROP",
                            payload: {
                              Table_Key:
                                e?.Entry_Type === "Journal Voucher"
                                  ? "Journal_Voucher"
                                  : e?.Entry_Type === "Bank Payment"
                                  ? "Bank_Payment"
                                  : e?.Entry_Type === "Bank Receipt"
                                  ? "Bank_Receipt"
                                  : e?.Entry_Type === "Cash Payment"
                                  ? "Cash_Payment"
                                  : e?.Entry_Type === "Cash Receipt"
                                  ? "Cash_Receipt"
                                  : e?.Entry_Type === "Contra Voucher"
                                  ? "Contra_Voucher"
                                  : "",
                              props: {
                                show: true,
                                ParentPortalCloseFunction: () => {
                                  const input = document.getElementsByName(e.name);
                                  if (input[0]) {
                                    input[0].focus();
                                  }
                                  setOpen(false);
                                  dispatch({ type: "CLEAR_COMPONENT_PROP" });
                                },
                                TypeOfPortal: "Edit",
                              },
                            },
                          });
                        }}
                      >
                        <HiPencil className="icon_styling" />
                      </td>
                      <td onClick={() => handleDeleteModal(e._id)}>
                        <MdDelete />
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
        ) : (
          <p>No {tableFor} Data Avalible</p>
        )}
      </div>
      <div className="balanceDetails">
        {tableFor !== "Delivery" && (
          <Button
            action={() => handleToggleFun(tableFor)}
            text={`Add ${tableFor}`}
            name="paymentsBtn"
            type={""}
            children={""}
            disabled={""}
          />
        )}

        <div>
          <p>Balance Amount : {Amount}</p>
        </div>
      </div>
    </>
  );
};

export default TransacionBrokerTable;

// {
//   ParentPortalCloseFunction: () => {},
//   show: open,
//   TypeOfPortal: "Add",
//   submitType: "Save",
//   onClose: () => {},
// }
